module.exports = __webpack_public_path__ + "img/parents.290dfa24.svg";